// @ts-check
export default {
  en: {
    translation: {
      loaded: 'Rss has been loaded',
      exist: 'Rss already exists',
      invalid: 'Rss is invalid',
      loading: 'Rss is loading',
    },
  },
};
